import React from 'react';

export default function TrialBillingConsent({ checked, onChange, price, days = 30 }) {
  return <div className="my-4 rounded-lg border border-bookish-purple/20 p-4">
    <label className="flex items-start gap-3 py-2 min-h-[44px]">
      <input type="checkbox" className="mt-1" checked={checked} onChange={event => onChange(event.target.checked)} />
      <span>I agree to automatically charge my card {price} when my {days}-day free trial ends and renew my membership at that rate until I cancel.</span>
    </label>
    <p className="mt-2 text-sm">This is optional. Leave it unchecked to start your trial without a card. Your membership becomes inactive after {days} days unless you activate billing in Settings → Membership &amp; Billing. You can cancel automatic renewal through Stripe.</p>
  </div>;
}
